// ADR 16.10.26e §4, 17.10.26f §2 — the web's reduced-motion hook.
//
// CSS handles every other motion rule (`motion-safe:` utilities, and
// `index.css` zeroing durations), but a rAF loop is neither, so it reads the
// media query itself. It subscribes to `change`, so a learner who toggles the
// setting mid-animation gets the still at once. An absent `matchMedia` (jsdom,
// a very old browser) reads as `false` and subscribes to nothing.

import { useSyncExternalStore } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

const query = (): MediaQueryList | null =>
  typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null

function subscribe(onChange: () => void): () => void {
  const list = query()
  if (list === null) return () => undefined
  list.addEventListener('change', onChange)
  return () => list.removeEventListener('change', onChange)
}

const snapshot = () => query()?.matches === true

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, snapshot)
}
